import FormSection from '@/components/Forms/FormSection';
import { CheckboxInput } from '@palmetto/palmetto-components';

type AttestationSectionProps = {
  permitAttestLabel: string;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  values: any;
  isSubmitting: boolean;
  touched: any;
  errors: any;
  isPackageEditable?: boolean;
};

export const AttestationSection = ({
  permitAttestLabel,
  setFieldValue,
  values,
  isSubmitting,
  touched,
  errors,
  isPackageEditable = true,
}: AttestationSectionProps) => {
  return (
    <FormSection title="Permit Attestation">
      <CheckboxInput
        id="permitAttestationCheckbox"
        name="permitAttestationCheckbox"
        label={permitAttestLabel}
        onChange={(event) => setFieldValue('permitAttestationCheckbox', event.target.checked)}
        isChecked={Boolean(values.permitAttestationCheckbox)}
        isDisabled={isSubmitting || !isPackageEditable}
        error={touched.permitAttestationCheckbox && (errors.permitAttestationCheckbox as string)}
      />
    </FormSection>
  );
};
